(function () {
  if (customElements.get('collection-series')) return;

  const pad = (n) => (n < 10 ? '0' + n : String(n));

  class CollectionSeries extends HTMLElement {
    connectedCallback() {
      const blocks = this.querySelectorAll('[data-series-block]');
      blocks.forEach((block) => this.initBlock(block));
    }

    initBlock(block) {
      const slides = Array.from(block.querySelectorAll('[data-slide-index]'));
      const panels = Array.from(block.querySelectorAll('[data-panel-index]'));
      const ctas = Array.from(block.querySelectorAll('[data-cta-index]'));
      const progressBars = Array.from(block.querySelectorAll('[data-progress-index]'));
      const breadcrumbCounter = block.querySelector('[data-counter-current]');
      const progressCounter = block.querySelector('[data-progress-current]');
      const prevBtn = block.querySelector('[data-carousel-prev]');
      const nextBtn = block.querySelector('[data-carousel-next]');
      const total = slides.length;
      if (!total) return;

      // When series_count == 2, Liquid duplicates slides (4 total: A, B, A', B').
      // panels/ctas/progress stay at 2 — one per UNIQUE model. Map slide index to
      // model index via data-model-index when present; fall back to slide idx.
      const modelIndexFor = (slideIdx) => {
        const slide = slides[slideIdx];
        if (slide && slide.dataset.modelIndex !== undefined) {
          const parsed = parseInt(slide.dataset.modelIndex, 10);
          if (!Number.isNaN(parsed)) return parsed;
        }
        return slideIdx;
      };

      const state = { active: 0 };

      const activate = (rawIdx) => {
        const idx = ((rawIdx % total) + total) % total;
        state.active = idx;

        const prevIdx = (idx - 1 + total) % total;
        const nextIdx = (idx + 1) % total;

        slides.forEach((slide, i) => {
          slide.classList.remove('is-active', 'is-prev', 'is-next');
          if (i === idx) slide.classList.add('is-active');
          else if (total > 1 && i === nextIdx) slide.classList.add('is-next');
          else if (total > 2 && i === prevIdx) slide.classList.add('is-prev');
        });

        const modelIdx = modelIndexFor(idx);

        panels.forEach((panel, i) => {
          const on = i === modelIdx;
          panel.classList.toggle('is-active', on);
          if (on) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });

        ctas.forEach((cta, i) => {
          const on = i === modelIdx;
          cta.classList.toggle('is-active', on);
          if (on) {
            cta.removeAttribute('hidden');
            cta.removeAttribute('tabindex');
          } else {
            cta.setAttribute('hidden', '');
            cta.setAttribute('tabindex', '-1');
          }
        });

        progressBars.forEach((bar, i) => {
          const on = i === modelIdx;
          bar.classList.toggle('is-active', on);
          bar.setAttribute('aria-current', on ? 'true' : 'false');
        });

        const padded = pad(modelIdx + 1);
        if (breadcrumbCounter) breadcrumbCounter.textContent = padded;
        if (progressCounter) progressCounter.textContent = padded;
      };

      progressBars.forEach((bar, i) => {
        bar.addEventListener('click', () => {
          // Jump to first slide that maps to this model index.
          const targetIdx = slides.findIndex((_, sIdx) => modelIndexFor(sIdx) === i);
          activate(targetIdx >= 0 ? targetIdx : i);
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', () => activate(state.active - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => activate(state.active + 1));
    }
  }

  customElements.define('collection-series', CollectionSeries);
})();
